require('./ChatCollapsed.scss');
const PropTypes = require('prop-types');
// @vendors
const React = require('react');
// @utilities
const { FormattedText } = require('core/i18n').i18n;
// @components
const ChatStatusContainer = require('components/chat/status/ChatStatusContainer');
// @constants
const {
    CHAT_CONVERSATION_STATUS: {
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE
    }
} = require('constants/chat');
// @images
const chatIcon = require('assets/icons/chat-icon.svg');

class ChatCollapsed extends React.Component {
    constructor(props) {
        super(props);

        this.handleToggleWindow = this.handleToggleWindow.bind(this);
    }

    handleToggleWindow() {
        const { toggleWindow } = this.props;
        toggleWindow();
    }

    render() {
        const { conversationStatus, isChatAvailable } = this.props;
        let chatStatus;
        if (conversationStatus !== INACTIVE || !isChatAvailable) {
            chatStatus = (<ChatStatusContainer />)
        } else {
            chatStatus = null;
        }
        return (
            <div className="chat-collapsed">
                <button className="chat-collapsed__bubble" onClick={this.handleToggleWindow}>
                    {chatStatus}
                    <img alt="chat" src={chatIcon} className="chat-collapsed__icon" />
                    <div className="chat-collapsed__hover"></div>
                </button>
                <div className="chat-collapsed__label"><FormattedText value="chat-title" /></div>
            </div>
        );
    }
}

ChatCollapsed.propTypes = {
    chatAvailabilityStatusData: PropTypes.object.isRequired,
    conversationStatus: PropTypes.oneOf([
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE
    ]).isRequired,
    isChatAvailable: PropTypes.bool.isRequired,
    startConversation: PropTypes.func.isRequired,
    toggleWindow: PropTypes.func.isRequired,
};
module.exports = ChatCollapsed;
